import PetrohubSampleApi from '../../../../services/api/PetrohubSampleApi';
import { doSearchStoreAction, loadGridColumnSettingStoreAction, loadSavedFilterStoreAction } from '../../../Generic/SearchPage/actions/searchPageActions';
import { ObjectTypes, SortDirection } from '../../../../utils/constants';
import { petrohubSampleSearchActions as searchPageSliceActions } from '../slices/petrohubSampleSearchSlice';
import { getEndDateWithTime, getStartDateWithTime } from '../../../../utils/constants/datetime';
import { getUserTimezone } from '../../../../hooks/useAuth';

const getStateSliceForSearchPage = (state) => state.petrohubSampleSearch;
export const loadGridColumnSettingStoreActionHandler = () => async (dispatch, getState) => loadGridColumnSettingStoreAction({
  dispatch,
  getState,
  searchPageSliceActions,
  getStateSliceForSearchPage,
  objectTypeGridColumns: ObjectTypes.SampleSearchGrid
});

export const loadSavedFilterStoreActionHandler = () => async (dispatch, getState) => loadSavedFilterStoreAction({ dispatch, getState, searchPageSliceActions, getStateSliceForSearchPage, objectTypeForSaveUserFilter: ObjectTypes.PetrohubSampleSearchUserFilter });

export const doSearchStoreActionHandler = () => async (dispatch, getState) => {
  const state = getState();
  const timezone = getUserTimezone(state);
  const { assignedDivisions, assignedSourceSystems } = state.auth.loginUser;
  const { tableInfo } = state.sampleTrackingSearch;
  const searchParamBuilder = (filter) => ({
    locationIdentifier: filter?.LocationIdentifier ?? null,
    locationFormat: filter?.LocationFormat ?? '',
    sampleNumber: filter?.SampleNumber ?? '',
    maxxID: filter?.MaxxID ?? '',
    clientID: filter?.ClientID ?? '',
    analysisType: filter?.AnalysisType ? filter.AnalysisType : null,
    sampleStatus: filter?.SampleStatus ? filter.SampleStatus : null,
    maxxAlertStatus: filter?.MaxxAlertStatus ? filter.MaxxAlertStatus : null,
    clientReviewStatus: filter?.ClientReviewStatus ? filter.ClientReviewStatus : null,
    clientIDs: filter?.clientIDs ?? [],
    reportAddressIDs: filter?.reportAddressIDs ?? [],
    scenarioIDs: filter?.scenarioIDs ?? [],
    attentionName: filter?.AttentionName ?? '',
    area: filter?.Area ?? '',
    samplePoint: filter?.SamplePoint ?? '',
    jobNumber: filter?.JobNumber ?? '',
    matrix: filter?.Matrix ? filter.Matrix : null,
    projectNumber: filter?.ProjectNumber ?? null,
    poNumber: filter?.PoNumber ?? null,
    receivedDateFrom: filter?.ReceivedDateFrom ? getStartDateWithTime(filter?.ReceivedDateFrom, timezone).toISOString() : null,
    receivedDateTo: filter?.ReceivedDateTo ? getEndDateWithTime(filter?.ReceivedDateTo, timezone).toISOString() : null,
    sampleDateFrom: filter?.SampleDateFrom ? getStartDateWithTime(filter?.SampleDateFrom, timezone).toISOString() : null,
    sampleDateTo: filter?.SampleDateTo ? getEndDateWithTime(filter?.SampleDateTo, timezone).toISOString() : null,
    functionality: filter?.Functionality,
    sourceSystemIDs: assignedSourceSystems,
    divisionIDs: assignedDivisions,
    sortBy: SortDirection.combineSortBy(tableInfo.sortColumn, tableInfo.sortDirection)
  });

  await doSearchStoreAction({
    dispatch,
    getState,
    searchPageSliceActions,
    getStateSliceForSearchPage,
    searchParamBuilder,
    searchWithPaginationApi: PetrohubSampleApi.searchSamples,
    postResultsProcessHandler: null
  });
};
